export default __webpack_public_path__ + "static/badge-enter-end-323dcc6c81a885ec32097c87e459115d.webp";